module.exports = __webpack_public_path__ + "static/media/country_ws.b521d3f1.webp";